// @flow
import * as React from 'react'
import shallowEqual from 'mz-utils/shallowEqual'
import RadioField from 'mz-ui-kit/form/RadioField'
import type { Input, Meta } from 'mz-ui-kit/core/BaseField'
import { wrapWithField } from '../../Field'
import CreditcardIcon from '../assets/creditcard'
import {
  Container,
  BrandContainer,
  ExistingLabel,
} from '../CreditCardItem/elements'

// Types
export type Props = {
  input: Input,
  meta: Meta,
  activeValue: any,
  displayName: React.Node,
}

/**
 * General reponsive card elemenent for showing payment option
 * @param  {Object} props.option   A payment option object
 * @return {React.Element}
 */
const SpecialCreditCardItem = ({
  activeValue,
  displayName,
  ...rest
}: Props) => {
  const active = !!rest.input && shallowEqual(rest.input.value, activeValue)

  const handleContainerClick = () => {
    const { onChange } = rest.input
    if (active) {
      return
    }
    onChange && onChange(activeValue)
  }

  return (
    <Container $active={active} onClick={handleContainerClick}>
      <RadioField {...rest} activeValue={activeValue} inactiveValue={null} />
      <BrandContainer>
        <CreditcardIcon />
      </BrandContainer>
      <ExistingLabel>{displayName}</ExistingLabel>
    </Container>
  )
}

export default wrapWithField(SpecialCreditCardItem)
